<template>
  <div>
    <div class="intro-y box flex flex-col justify-between p-5">
      <!-- BEGIN: Data List -->
      <div>
        <!-- BEGIN: Wizard Layout -->

        <div class="intro-y">
          <div
            class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
          >
            <div
              class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
            >
              <button
                :class="[
                  'w-10 h-10 rounded-full btn',
                  currentStep == 1
                    ? 'btn-primary'
                    : 'text-gray-600 bg-gray-200 dark:bg-dark-1'
                ]"
              >
                1
              </button>
              <div
                class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto"
              >
                Tender Details
              </div>
            </div>
            <div
              class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
            >
              <button
                :class="[
                  'w-10 h-10 rounded-full btn',
                  currentStep == 2
                    ? 'btn-primary'
                    : 'text-gray-600 bg-gray-200 dark:bg-dark-1'
                ]"
              >
                2
              </button>
              <div
                class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
              >
                Expense Details
              </div>
            </div>
            <div
              class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
            >
              <button
                :class="[
                  'w-10 h-10 rounded-full btn',
                  currentStep == 3
                    ? 'btn-primary'
                    : 'text-gray-600 bg-gray-200 dark:bg-dark-1'
                ]"
              >
                3
              </button>
              <div
                class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
              >
                Lot Details
              </div>
            </div>
            <div
              class="wizard__line hidden lg:block w-2/3 bg-gray-200 dark:bg-dark-1 absolute mt-5"
            ></div>
          </div>
          <div class="w-full lg:w-2/3 m-auto mt-5" v-if="currentStep == 1">
            <div>
              <div class="grid grid-cols-12 gap-4 gap-y-4 mt-2">
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-1" class="form-label mb-0"
                    >Tender Name</label
                  >
                  <input
                    id="input-wizard-1"
                    v-model="formData.tender_name"
                    type="text"
                    name="tender_name"
                    :class="{
                      'border-theme-6': validate.tender_name.$error
                    }"
                    class="form-control"
                  />
                  <template v-if="validate.tender_name.$error">
                    <div
                      v-for="(error, index) in validate.tender_name.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Declare Date</label
                  >
                  <Litepicker
                    v-model="formData.declare_date"
                    :options="{
                      autoApply: false,
                      showWeekNumbers: true,
                      format: 'YYYY-MM-DD',
                      dropdowns: {
                        minYear: 1990,
                        maxYear: 2025,
                        months: true,
                        years: true
                      },
                      minDate: new Date(
                        new Date().getTime() - 24 * 60 * 60 * 1000
                      )
                    }"
                    class="form-control block mx-auto"
                    :class="{
                      'border-theme-6': validate.declare_date.$error
                    }"
                  />
                  <template v-if="validate.declare_date.$error">
                    <div
                      v-for="(error, index) in validate.declare_date.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>

                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-3" class="form-label mb-0"
                    >Tender Date</label
                  >
                  <Litepicker
                    v-model="formData.tender_date"
                    :options="{
                      autoApply: false,
                      format: 'YYYY-MM-DD',
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1990,
                        maxYear: 2025,
                        months: true,
                        years: true
                      },
                      maxDate: new Date()
                    }"
                    :class="{
                      'border-theme-6': validate.tender_date.$error
                    }"
                    class="form-control block mx-auto"
                  />
                  <template v-if="validate.tender_date.$error">
                    <div
                      v-for="(error, index) in validate.tender_date.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-2" class="form-label mb-0"
                    >Total Lots</label
                  >
                  <input
                    id="input-wizard-2"
                    disabled
                    type="text"
                    v-model="formData.total_lots"
                    class="form-control"
                    :class="{
                      'border-theme-6': validate.total_lots.$error
                    }"
                  />
                  <template v-if="validate.total_lots.$error">
                    <div
                      v-for="(error, index) in validate.total_lots.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>

                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-5" class="form-label mb-0"
                    >Tender Place</label
                  >
                  <TomSelect
                    v-model="formData.tender_place"
                    :class="{
                      'border-theme-6': validate.tender_place.$error
                    }"
                    :options="{
                      placeholder: ''
                    }"
                  >
                    <option value="0">Select Place</option>
                    <option
                      v-for="(location, index) in pageData.locationList"
                      :key="index"
                      :value="location.id"
                    >
                      {{ location.location_name }}
                    </option>
                  </TomSelect>
                  <template v-if="validate.tender_place.$error">
                    <div
                      v-for="(error, index) in validate.tender_place.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-4" class="form-label mb-0"
                    >Total Weight</label
                  >
                  <input
                    id="input-wizard-4"
                    disabled
                    type="text"
                    v-model="formData.total_weight"
                    class="form-control"
                    :class="{
                      'border-theme-6': validate.total_weight.$error
                    }"
                  />
                  <template v-if="validate.total_weight.$error">
                    <div
                      v-for="(error, index) in validate.total_weight.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>

                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Company Name</label
                  >
                  <TomSelect
                    v-model="formData.company_name"
                    :class="{
                      'border-theme-6': validate.company_name.$error
                    }"
                    :options="{
                      placeholder: ''
                    }"
                  >
                    <option value="0">Select Company</option>
                    <option
                      v-for="(company, index) in pageData.companyList"
                      :key="index"
                      :value="company.id"
                      >{{ company.firm_name }}
                    </option>
                  </TomSelect>
                  <template v-if="validate.company_name.$error">
                    <div
                      v-for="(error, index) in validate.company_name.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Total Amount</label
                  >
                  <input
                    id="input-wizard-5"
                    disabled
                    type="text"
                    v-model="formData.total_amount"
                    class="form-control"
                  />
                </div>

                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Partner</label
                  >
                  <TomSelect
                    v-model="formData.partner_id"
                    :class="{
                      'border-theme-6': validate.partner_id.$error
                    }"
                    :options="{
                      placeholder: ''
                    }"
                  >
                    <option value="0">Select Partner Company</option>
                    <option
                      v-for="(partner, index) in pageData.partnerList"
                      :key="index"
                      :value="partner.id"
                      >{{ partner.firm_name }}
                    </option>
                  </TomSelect>
                  <template v-if="validate.partner_id.$error">
                    <div
                      v-for="(error, index) in validate.partner_id.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Total Expense</label
                  >
                  <input
                    id="input-wizard-5"
                    disabled
                    type="text"
                    v-model="formData.total_expense"
                    class="form-control"
                  />
                  <!-- <template v-if="validate.total_expense.$error">
                    <div
                      v-for="(error, index) in validate.total_expense
                        .$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template> -->
                </div>

                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Partnership (%)</label
                  >
                  <input
                    id="input-wizard-5"
                    type="text"
                    v-model="formData.partnership"
                    @keypress="$h.preventInvalidInput"
                    class="form-control"
                    :class="{
                      'border-theme-6': validate.partnership.$error
                    }"
                  />
                  <template v-if="validate.partnership.$error">
                    <div
                      v-for="(error, index) in validate.partnership.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="intro-y col-span-12 sm:col-span-6">
                  <label for="input-wizard-6" class="form-label mb-0"
                    >Average Per/ct</label
                  >
                  <input
                    id="input-wizard-5"
                    disabled
                    type="text"
                    v-model="formData.avg"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-2/3 m-auto mt-5" v-if="currentStep == 2">
            <div class="">
              <div class="flex">
                <p class="font-bold text-md mt-2">Upload Excel</p>
                <button
                  class="btn btn-primary btn-sm ml-5 mb-4"
                  @click="clearDropzone('excel', 0)"
                >
                  <UploadIcon class="h-4 w-4 mr-2" /> Upload
                </button>
                <a
                  class="ml-2 mt-2"
                  target="_blank"
                  :href="baseURL + formData.expense_file"
                  >Link</a
                >
              </div>
              <!-- BEGIN: Form Layout -->
              <p class="font-bold text-lg pb-2">Expense Details</p>
              <div class=" w-full">
                <table class="border-2 pt-5 table-auto w-full">
                  <thead>
                    <tr class="border">
                      <th style="width:5%">SR.NO</th>
                      <th style="width:45%">Expense Name</th>
                      <th style="width:40%">Amount</th>
                      <th style="width:10%" class="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody class="border-2">
                    <tr
                      class=""
                      v-for="(item, index) in formData.expense_details"
                      :key="index"
                    >
                      <td class="whitespace-nowrap border-b text-center">
                        {{ index + 1 }}
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <TomSelect
                          v-model="item.expense_name"
                          :options="{
                            placeholder: ''
                          }"
                        >
                          <option value="0">Select Expense Name</option>
                          <option
                            v-for="(expense, index) in pageData.expenseList"
                            :key="index"
                            :value="expense.id"
                            >{{ expense.expense_name }}
                          </option>
                        </TomSelect>
                      </td>
                      <td class="whitespace-nowrap w-24" style="padding: 2px;">
                        <input
                          type="text"
                          v-model="item.amount"
                          class="form-control rounded-none w-full"
                          placeholder="Amount"
                          aria-describedby="input-group-3"
                          @keypress="$h.preventInvalidInput"
                        />
                      </td>
                      <td
                        class="whitespace-nowrap text-center"
                        v-if="index != 0"
                      >
                        <button
                          class="btn btn-danger btn-sm p-1"
                          @click="deleteRow(index)"
                        >
                          <Trash2Icon class="h-4 w-4" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="text-right mt-4">
                <button class="btn btn-secondary btn-sm" @click="addRow">
                  <PlusIcon class="h-4 w-4 mr-2" /> Add
                </button>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-6 mt-5" v-if="currentStep == 3">
            <div class="intro-y col-span-12 p-5">
              <!-- BEGIN: Form Layout -->
              <p class="font-bold text-lg pb-2">Lot Details</p>
              <div class="w-full table-container overflow-x-auto">
                <table class="border-2 pt-5 table-auto w-full">
                  <thead class="">
                    <tr class="border">
                      <th class="py-2">SR.NO</th>
                      <th class="whitespace-nowrap">
                        Lot No
                      </th>
                      <th>Weight</th>
                      <th>Result</th>
                      <th>Color</th>
                      <!-- <th>Purity</th> -->
                      <th>Blue Uv</th>
                      <th>Brown</th>
                      <th>Comment</th>
                      <th>Flow</th>
                      <th>Tension</th>
                      <th>Eyeclc-R</th>
                      <th>Eyeclc-F</th>
                      <th>Center</th>
                      <!-- <th>Price/ct</th>
                      <th class="whitespace-nowrap">Total Price</th> -->
                      <th>Video</th>
                      <th>Cap</th>
                      <th>Image</th>
                      <th class="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody class="border-2">
                    <tr
                      class=""
                      v-for="(item, index) in formData.lot_details"
                      :key="index"
                    >
                      <td class="text-center border-2">
                        {{ index + 1 }}
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <input
                          type="text"
                          v-model="item.lot_no"
                          class="form-control rounded-none w-20 py-1"
                          placeholder=""
                          aria-describedby="input-group-3"
                        />
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <input
                          type="text"
                          v-model="item.weight"
                          class="form-control rounded-none w-20 py-1"
                          placeholder=""
                          @input="TotalPrice(index)"
                          aria-describedby="input-group-3"
                          @keypress="$h.preventInvalidInput"
                        />
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.result"
                          class="w-20 form-select py-1"
                        >
                          <option value="no_result" label="???">???</option>
                          <option
                            v-for="(result, index) in pageData.colorList"
                            :key="index"
                            :value="result.id"
                            >{{ result.color_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.color"
                          class="w-20 form-select py-1"
                        >
                          <option value="no_result" label="??">??</option>
                          <option
                            v-for="(color, index) in pageData.colorList"
                            :key="index"
                            :value="color.id"
                            >{{ color.color_name }}
                          </option>
                        </select>
                      </td>
                      <!-- <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.purity"
                          class="w-20 form-select py-1"
                        >
                          <option value="no_result" label="??">??</option>
                          <option
                            v-for="(purity, index) in pageData.purityList"
                            :key="index"
                            :value="purity.id"
                            >{{ purity.purity_name }}
                          </option>
                        </select>
                      </td> -->
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.blue_uv"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(blueUv, index) in pageData.blueUvList"
                            :key="index"
                            :value="blueUv"
                            >{{ blueUv }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.brown"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(brown, index) in pageData.brownList"
                            :key="index"
                            :value="brown.id"
                            >{{ brown.brown_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.comment"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(comment, index) in pageData.commentList"
                            :key="index"
                            :value="comment.id"
                            >{{ comment.comment_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.flow"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(flow, index) in pageData.flowList"
                            :key="index"
                            :value="flow.id"
                            >{{ flow.fluerocent_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.tension"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(tension, index) in pageData.tensionList"
                            :key="index"
                            :value="tension.id"
                            >{{ tension.tension_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.eyeclc_r"
                          class="w-20 form-select py-1"
                        >
                          <!-- <option value="no_result" label="??">??</option> -->
                          <option
                            v-for="(eyeclc_r, index) in pageData.colorList"
                            :key="index"
                            :value="eyeclc_r.id"
                            >{{ eyeclc_r.color_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.eyeclc_f"
                          class="w-20 form-select py-1"
                        >
                          <!-- <option value="no_result" label="??">??</option> -->
                          <option
                            v-for="(eyeclc_f, index) in pageData.colorList"
                            :key="index"
                            :value="eyeclc_f.id"
                            >{{ eyeclc_f.color_name }}
                          </option>
                        </select>
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <select
                          v-model="item.center"
                          class="w-20 form-select py-1"
                        >
                          <option
                            v-for="(center, index) in pageData.purityList"
                            :key="index"
                            :value="center.id"
                            >{{ center.purity_name }}
                          </option>
                        </select>
                      </td>
                      <!-- <td class="whitespace-nowrap w-24">
                        <input
                          type="text"
                          v-model="item.price_ct"
                          @input="TotalPrice(index)"
                          class="form-control rounded-none w-20 py-1"
                          placeholder=""
                          aria-describedby="input-group-3"
                          @keypress="$h.preventInvalidInput"
                        />
                      </td>
                      <td class="whitespace-nowrap w-24">
                        <input
                          type="text"
                          v-model="item.total_price"
                          disabled
                          class="form-control rounded-none w-20 py-1"
                          placeholder=""
                          aria-describedby="input-group-3"
                          @keypress="$h.preventInvalidInput"
                        />
                      </td> -->
                      <td class="pl-8">
                        <div class="w-16">
                          <button
                            class="btn btn-outline-primary btn-xs py-1 px-1"
                            @click="clearDropzone('video', index)"
                          >
                            <UploadIcon class="h-3 w-3" />
                          </button>
                          <a
                            v-if="formData.lot_details[index].video != '' && formData.lot_details[index].video != null"
                            class="ml-2 btn btn-outline-primary btn-xs py-1 px-1"
                            target="_blank"
                            :href="baseURL + formData.lot_details[index].video"
                            ><ImageIcon class="h-3 w-3"
                          /></a>
                        </div>
                      </td>
                      <td class="pl-8">
                        <div class="w-16">
                          <button
                            class="btn btn-outline-primary btn-xs py-1 px-1"
                            @click="clearDropzone('cap', index)"
                          >
                            <UploadIcon class="h-3 w-3" />
                          </button>
                          <a
                            v-if="formData.lot_details[index].cap != '' && formData.lot_details[index].cap != null"
                            class="ml-2 btn btn-outline-primary btn-xs py-1 px-1"
                            target="_blank"
                            :href="baseURL + formData.lot_details[index].cap"
                            ><ImageIcon class="h-3 w-3"
                          /></a>
                        </div>
                      </td>
                      <td class="pl-8">
                        <div class="w-16">
                          <button
                            class="btn btn-outline-primary btn-xs py-1 px-1"
                            @click="clearDropzone('image', index)"
                          >
                            <UploadIcon class="h-3 w-3" />
                          </button>
                          <a
                            v-if="formData.lot_details[index].image != '' && formData.lot_details[index].image != null"
                            class="ml-2 btn btn-outline-primary btn-xs py-1 px-1"
                            target="_blank"
                            :href="baseURL + formData.lot_details[index].image"
                            ><ImageIcon class="h-3 w-3"
                          /></a>
                        </div>
                      </td>
                      <td
                        class="whitespace-nowrap text-center"
                        style="padding: 2px;"
                        v-if="index != 0"
                      >
                        <button
                          class="btn btn-danger btn-sm p-1"
                          @click="deleteLotRow(index)"
                        >
                          <Trash2Icon class="h-4 w-4" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="flex justify-between items-center mt-4">
                <div class="">
                  <div>
                    <button class="btn btn-secondary btn-sm" @click="addSubRow">
                      <PlusIcon class="h-4 w-4 mr-2" /> Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-8"
            :class="{
              'w-full lg:w-2/3 m-auto': currentStep == 1 || currentStep == 2
            }"
          >
            <button
              v-if="currentStep != 1"
              class="btn btn-secondary w-24"
              @click="goToPreviousStep"
            >
              Previous
            </button>
            <button
              v-if="currentStep == 3"
              :disabled="pageData.submit"
              type="button"
              @click="submitForm"
              class="btn btn-primary w-24 ml-2"
            >
              Save
              <LoadingIcon
                v-if="pageData.submit"
                icon="oval"
                color="white"
                class="w-4 h-4 ml-2"
              />
            </button>
            <button
              v-else
              class="btn btn-primary w-24 ml-2"
              @click="goToNextStep"
            >
              Next
            </button>
          </div>
        </div>
        <!-- END: Wizard Layout -->
      </div>
      <!-- END: Data List -->
    </div>

    <div id="upload-image-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-body p-10">
            <!-- <div id="vertical-form"> -->
            <div class="flex flex-col justify-between mt-5">
              <!-- BEGIN: Data List -->
              <div class="intro-y overflow-auto">
                <div class="flex items-center">
                  <h2 class="intro-y text-lg font-medium mr-5">
                    Upload File Here
                  </h2>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="intro-y col-span-12">
                  <!-- BEGIN: Dropzone -->
                  <div class="dropzone" id="stock-dropzone"></div>
                  <!-- END: Dropzone -->
                </div>
              </div>
              <!-- END: Data List -->
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Details saved successfully!</div>
        <div class="text-gray-600 mt-1"></div>
      </div>
    </div>
    <!-- END: Success Notification Content -->
    <!-- BEGIN: Failed Notification Content -->
    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Something went wrong!</div>
        <div class="text-gray-600 mt-1">
          Please check the fileld form.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, reactive, onMounted, inject, watch, toRefs } from 'vue'
import { BASE_URL } from '@/constants/config.js'
import { ImageIcon, UploadIcon } from '@zhuowenli/vue-feather-icons'
import { helper as $h } from '@/utils/helper'
import Swal from 'sweetalert2'
import Dropzone from 'dropzone'
import Toastify from 'toastify-js'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'

const swal = inject('$swal')
const route = useRoute()
const router = useRouter()
const stockDropzone = ref(null)
const baseURL = ref(BASE_URL)
const currentStep = ref(1)
const totalSteps = 3
const pageData = reactive({
  errors: [],
  locationList: [],
  companyList: [],
  partnerList: [],
  colorList: [],
  brownList: [],
  tensionList: [],
  flowList: [],
  tensionList: [],
  purityList: [],
  // blueUvList: [],
  blueUvList: Array.from({ length: 76 }, (_, i) =>
    i.toString().padStart(3, '0')
  ),
  modelIndex: 0,
  modelFileType: '',
  submit: false,
  token: localStorage.getItem('token')
})

const goToNextStep = () => {
  if (currentStep.value < totalSteps) {
    currentStep.value++
  }
}

const goToPreviousStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--
  }
}
const screenData = reactive({
  transaction_no: '',
  issuer: '',
  status: '0',
  employee_type: '3',
  employee_id: '',
  process_id: '0',
  employees: [],
  parties: [],
  process_items: [],
  emp_hit: 1
})
const formData = reactive({
  id: '',
  tender_name: '',
  total_lots: '',
  tender_date: '',
  total_weight: '',
  tender_place: '0',
  total_amount: '',
  company_name: '0',
  total_expense: '',
  partner_id: '0',
  avg: '',
  partnership: '',
  declare_date: '',
  expense_file: '',
  expense_details: [
    {
      expense_name: '',
      amount: ''
    }
  ],
  lot_details: [
    {
      lot_no: '',
      weight: '',
      result: 'no_result',
      color: 'no_result',
      purity: 'no_result',
      blue_uv: '',
      brown: '',
      comment: '',
      flow: '',
      tension: '',
      eyeclc_r: '',
      eyeclc_f: '',
      center: '',
      price_ct: '',
      total_price: '',
      video: '',
      cap: '',
      image: ''
    }
  ]
})

const rules = {
  tender_name: {
    required
  },
  total_lots: {
    required
  },
  tender_date: {
    required
  },
  total_weight: {
    required
  },
  tender_place: {
    required
  },
  // total_amount: {
  //   required
  // },
  company_name: {
    required
  },
  // total_expense: {
  //   required
  // },
  partner_id: {
    required
  },
  // avg: {
  //   required
  // },
  partnership: {
    required
  },
  declare_date: {
    required
  }
}
const validate = useVuelidate(rules, toRefs(formData))

const TotalPrice = index => {
  const item = formData.lot_details[index]
  item.total_price = $h.myFloat(item.weight * item.price_ct)
}

const TotalAvg = computed(() => {
  formData.avg = $h.myFloat(formData.total_amount / formData.total_weight)
})

watch(TotalAvg, (newValue, oldValue) => {
  formData.avg = newValue
})

const TotalLotNo = computed(() => {

  // return 1;
  return formData.lot_details.length;
})

watch(TotalLotNo, (newValue, oldValue) => {
  formData.total_lots = newValue
})

const TotalExpense = computed(() => {
  let total = 0
  for (const item of formData.expense_details) {
    total += parseFloat(item.amount) || 0
  }
  return total
})

watch(TotalExpense, (newValue, oldValue) => {
  formData.total_expense = newValue
})

const TotalAmount = computed(() => {
  let total = 0
  for (const item of formData.lot_details) {
    total += parseFloat(item.total_price) || 0
  }
  return total
})

watch(TotalAmount, (newValue, oldValue) => {
  formData.total_amount = newValue
})

const TotalWeight = computed(() => {
  let total = 0
  for (const item of formData.lot_details) {
    total += parseFloat(item.weight) || 0
  }
  return total
})

watch(TotalWeight, (newValue, oldValue) => {
  formData.total_weight = newValue
})

function get_company_list() {
  axios({
    url: 'api/master/tender_company_list',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    pageData.companyList = res.data.items
  })
}

function get_location_list() {
  axios({
    url: 'api/master/dp_location',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    pageData.locationList = res.data.items
  })
}

function get_partner_list() {
  axios({
    url: 'api/master/partner_company_list',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    pageData.partnerList = res.data.items
  })
}

function get_parameters() {
  axios({
    url: 'api/tender/params',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    pageData.colorList = res.data.color
    pageData.brownList = res.data.brown
    pageData.tensionList = res.data.tension
    pageData.flowList = res.data.fluerocent
    pageData.purityList = res.data.purity
    pageData.commentList = res.data.comment
  })
}

function get_expense_list() {
  axios({
    url: 'api/master/dp_expense',
    method: 'post',
    baseURL: BASE_URL,
    data: { type: window.btoa(1) },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    pageData.expenseList = res.data.items
  })
}

const addRow = () => {
  formData.expense_details.push({
    // expense_name: String(pageData.expenseList[0].id),
    expense_name: '',
    amount: ''
  })
}

const deleteRow = index => {
  console.log(index, 'index11')
  swal({
    title: 'Are you sure?',
    text: 'You are about to Remove' + ' Record!',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Confirm',
    showLoaderOnConfirm: true,
    cancelButtonText: 'Cancel',
    preConfirm: () => {
      return true
    },

    allowOutsideClick: () => !Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      console.log(index, 'index')
      formData.expense_details.splice(index, 1)
    }
  })
}
const addSubRow = () => {
  formData.lot_details.push({
    // expense_name: String(pageData.expenseList[0].id),
    lot_no: '',
    weight: '',
    result: 'no_result',
    color: 'no_result',
    purity: 'no_result',
    blue_uv: '',
    brown: '',
    comment: '',
    flow: '',
    tension: '',
    eyeclc_r: '',
    eyeclc_f: '',
    center: '',
    price_ct: '',
    total_price: '',
    video: '',
    cap: '',
    image: ''
  })
}

const deleteLotRow = index => {
  swal({
    title: 'Are you sure?',
    text: 'You are about to Remove' + ' Record!',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Confirm',
    showLoaderOnConfirm: true,
    cancelButtonText: 'Cancel',
    preConfirm: () => {
      return true
    },

    allowOutsideClick: () => !Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      formData.lot_details.splice(index, 1)
    }
  })
}
const resetForm = () => {
  formData.tender_name = ''
  formData.tender_date = ''
  formData.total_weight = ''
  formData.tender_place = '0'
  formData.total_amount = ''
  formData.company_name = '0'
  formData.total_expense = ''
  formData.partner_id = '0'
  formData.avg = ''
  formData.partnership = ''
  formData.declare_date = ''
  formData.expense_file = ''
  formData.expense_details = [
    {
      expense_name: '',
      amount: ''
    }
  ]
  formData.lot_details = [
    {
      lot_no: '',
      weight: '',
      result: 'no_result',
      color: 'no_result',
      purity: 'no_result',
      blue_uv: '',
      brown: '',
      comment: '',
      flow: '',
      tension: '',
      eyeclc_r: '',
      eyeclc_f: '',
      center: '',
      price_ct: '',
      total_price: '',
      video: '',
      cap: '',
      image: ''
    }
  ]
  currentStep.value = 1
}
function submitForm() {
  validate.value.$touch()
  if (validate.value.$invalid) {
    Toastify({
      node: cash('#failed-notification-content')
        .clone()
        .removeClass('hidden')[0],
      duration: 3000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  } else {
    pageData.submit = true
    const params = {
      tender_name: formData.tender_name,
      total_lots: formData.total_lots,
      tender_date: formData.tender_date,
      total_weight: formData.total_weight,
      tender_place: formData.tender_place,
      total_amount: formData.total_amount,
      company_name: formData.company_name,
      total_expense: formData.total_expense,
      partner_id: formData.partner_id,
      avg: formData.avg,
      partnership: formData.partnership,
      declare_date: formData.declare_date,
      expense_file: formData.expense_file,
      expense_details: formData.expense_details,
      lot_details: formData.lot_details,
      id: btoa(formData.id)
    }
    axios({
      url: 'api/tender/create',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      config: { headers: { Accept: 'application/json' } }
    })
      .then(() => {
        pageData.submit = false
        Toastify({
          node: cash('#success-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        router.push('/tender')
      })
      .catch(err => {
        pageData.submit = false
        // errors.value = err.response.data.errors
        setTimeout(() => {
          pageData.errors = []
        }, 5000)
      })
  }
}

const get_tender_data = id => {
  const params = {
    id: id
  }

  let promise = axios({
    url: 'api/tender/edit',
    method: 'POST',
    params: params,
    baseURL: BASE_URL,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    config: { headers: { Accept: 'application/json' } }
  })
  return promise
    .then(result => result.data)
    .then(data => {
      formData.tender_name = data.item.tender_name
      formData.tender_date = data.item.tender_date
      formData.declare_date = data.item.declare_date
      formData.total_lots = data.item.total_lots
      formData.total_weight = data.item.total_weight
      formData.total_amount = data.item.total_amount
      formData.total_expense = data.item.total_expense
      formData.expense_file = data.item.expense_file
      formData.company_name = String(data.item.company_id)
      formData.tender_place = String(data.item.tender_place)
      formData.partner_id = String(data.item.partner_id)
      formData.partnership = data.item.partnership
      formData.expense_details = data.item.expense_details
      formData.lot_details = data.item.lot_details
      formData.id = data.item.id

      formData.expense_details.forEach(item => {
        if(item.expense_name == null) {

          item.expense_name = '0';
        }
      });
    })
    .catch(_error => {})
}
function getParties() {
  axios({
    url: 'api/master/tender_company_list',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        Accept: 'application/json'
      }
    }
  }).then(res => {
    screenData.parties = res.data.items
  })
}

onMounted(() => {
  getParties()
  get_company_list()
  get_location_list()
  get_parameters()
  get_partner_list()
  get_expense_list()

  if (route.params.id) {
    get_tender_data(route.params.id)
  }

  formData.total_lots = TotalLotNo.value

  stockDropzone.value = new Dropzone('#stock-dropzone', {
    url: `${BASE_URL}api/tender/upload?file_type=` + pageData.modelFileType,
    thumbnailWidth: 150,
    addRemoveLinks: true,
    maxFiles: 1,
    headers: {
      Authorization: 'Bearer ' + window.localStorage.getItem('token')
    },
    init: function() {
      this.on('error', function(file, errorMessage) {
        this.removeFile(file)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No more files please!'
        })
      })

      this.on('success', function(file, response) {
        const packetIndex = pageData.modelIndex
        const modelFileType = pageData.modelFileType
        console.log(response.file_name, 'response')

        if (modelFileType == 'image') {
          formData.lot_details[packetIndex].image = response.file_name
        } else if (modelFileType == 'video') {
          formData.lot_details[packetIndex].video = response.file_name
        } else if (modelFileType == 'cap') {
          formData.lot_details[packetIndex].cap = response.file_name
        } else if (modelFileType == 'excel') {
          formData.expense_file = response.file_name
        }
        cash('#upload-image-modal').modal('hide')

        // purchase.packet_details[packetIndex].url = response.path;

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'File Uploaded'
        })
        this.removeFile(file)
      })
    }
  })
})

const clearDropzone = (type, inx) => {
  pageData.modelFileType = type
  pageData.modelIndex = inx
  cash('#upload-image-modal').modal('show')
}
</script>
<style scoped>
a:link {
  text-decoration: underline;
}
.btn.btn-outline-primary.btn-xs.py-1:hover {
  background-color: transparent;
}
#new-rough-tender-modal {
  padding-left: 0 !important;
}
.modal-body-w {
  height: 100vh !important;
}
.overflow-auto {
  scrollbar-width: thin;
}
.overflow-x-auto {
  scrollbar-width: thin;
}
</style>
